import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UtilsService } from '../../services/utils.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  @Output() notify = new EventEmitter();
  parentToken: any;

  constructor(private readonly router: Router,
    private readonly route: ActivatedRoute, private readonly utilService: UtilsService) {

    this.route.queryParams.subscribe((params: Params) => {
      this.parentToken = params.token;
      if (this.parentToken != undefined) {
        sessionStorage.setItem('parentToken', this.parentToken);
      }
    });
  }
  isAdmin: boolean = false;

  ngOnInit(): void {
    this.isAdmin = this.utilService.getUserRole();
  }

  goToHome() {
    this.router.navigate(['/home']);
  }

  goToAdmin() {
    this.router.navigate(['/admin']);
  }

  isAdminPage() {
    if (window.location.href.indexOf('/admin') != -1) {
      return true;
    } else {
      return false;
    }
  }
}
